import { useSelector, useStore } from 'react-redux';

type Party = 'office' | 'talent';

export function invoiceDisputeActorKey(value: unknown, party: Party): string {
  const user = value as { id?: unknown; hygienistId?: unknown; dentistId?: unknown; isAdmin?: unknown } | null;
  const userId = Number(user?.id);
  const partyId = Number(party === 'office' ? user?.dentistId : user?.hygienistId);
  if (!user || user.isAdmin || !Number.isSafeInteger(userId) || userId <= 0
    || !Number.isSafeInteger(partyId) || partyId <= 0
    || (party === 'office' ? !!user.hygienistId : !!user.dentistId)) return '';
  return `${userId}:${party}:${partyId}`;
}

function matchingSessionActor(key: string, party: Party): string {
  if (!key) return '';
  try {
    const legacy = (window as any).TempStars?.User?.getCurrentUser;
    const stored = localStorage.getItem('userAccount');
    // During shell/React account reconciliation, disagreement is not authority
    // to retain private data or dispatch an action from the previous account.
    if (typeof legacy === 'function'
      && (stored === null || invoiceDisputeActorKey(legacy(), party) !== key)) return '';
    if (stored !== null && invoiceDisputeActorKey(JSON.parse(stored), party) !== key) return '';
    return key;
  } catch { return ''; }
}

export default function useInvoiceDisputeActor(party: Party) {
  const store = useStore();
  const selected = useSelector((state: any) => invoiceDisputeActorKey(state?.user, party));
  const actor = matchingSessionActor(selected, party);
  // Read the current store at every callback, including before React renders a
  // queued account switch. A captured render identity is insufficient here.
  const currentActor = () => matchingSessionActor(invoiceDisputeActorKey((store.getState() as any)?.user, party), party);
  return { actor, currentActor };
}
